export default __webpack_public_path__ + "static/media/helpful-icon.379864d9.svg";